import { HttpHeaders } from '@azure/ms-rest-js';
import { TokenProvider } from '../helpers/TokenProvider';

var AuthorizationPolicy = function AuthorizationPolicy(nextPolicy, _options) {
  var headerKey = 'Authorization';

  var addAuthorizationHeader = async function addAuthorizationHeader(request) {
    var copyRequest = request; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always falsy we need this condition

    if (!copyRequest.headers) {
      copyRequest.headers = new HttpHeaders();
    }

    var token = await TokenProvider.getAuthorizationToken();

    if (!copyRequest.headers.get(headerKey) && token) {
      copyRequest.headers.set(headerKey, token.toString());
    }
  };

  var sendRequest = async function sendRequest(request) {
    await addAuthorizationHeader(request);
    return nextPolicy.sendRequest(request);
  };

  return {
    sendRequest: sendRequest
  };
};

export var authorizationPolicy = function authorizationPolicy() {
  return {
    create: function create(nextPolicy, options) {
      return AuthorizationPolicy(nextPolicy, options);
    }
  };
};